<ul class="task-load-list">
  <li *ngFor="let unitTask of tasks" class="task-unit">{{unitTask.message}}</li>
</ul>